// assets/next-day.js
document.addEventListener("DOMContentLoaded", () => {
  console.info("✅ Next-day delivery JS loaded (using theme's product cards)");

  function flattenPins(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.map(x => String(x||"")).join("\n")
        .split(/\r?\n|,|\s+/).map(s => s.trim()).filter(Boolean);
    }
    if (typeof raw === "string") {
      return raw.split(/\r?\n|,|\s+/).map(s => s.trim()).filter(Boolean);
    }
    return String(raw).split(/\r?\n|,|\s+/).map(s => s.trim()).filter(Boolean);
  }

  document.querySelectorAll("[id^='ndd-validate-']").forEach(btn => {
    if (btn.__ndd_attached) return;
    btn.__ndd_attached = true;

    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const sectionId = btn.dataset.section || btn.id.replace("ndd-validate-","");
      let rawPins;
      try { rawPins = JSON.parse(btn.dataset.pins || "[]"); } catch(e) { rawPins = btn.dataset.pins; }
      const pins = flattenPins(rawPins);

      const input    = document.getElementById(`ndd-pin-input-${sectionId}`);
      const message  = document.getElementById(`ndd-validation-message-${sectionId}`);
      const modal    = document.getElementById(`ndd-modal-${sectionId}`);
      const wrapper  = document.getElementById(`ndd-wrapper-${sectionId}`);
      const products = document.getElementById(`ndd-products-${sectionId}`);

      const pinValue = (input?.value || "").trim();
      if (!pinValue) {
        if (message) { message.innerText = "Please enter a PIN."; message.style.color = "#c33"; }
        return;
      }

      if (pins.includes(pinValue)) {
        if (message) { message.innerText = "✅ Deliverable!"; message.style.color = "green"; }
        wrapper?.classList.remove("ndd-blur");
        products?.classList.remove("ndd-hidden");
        if (modal) modal.style.display = "none";

        // Save in cart attributes
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { next_day_pin: pinValue } })
        }).then(r => r.json()).then(data => {
          console.info("Cart updated with next_day_pin:", pinValue);
        });

      } else {
        if (message) { message.innerText = "❌ Not deliverable to this PIN."; message.style.color = "red"; }
      }
    });
  });

  // Restore saved PIN (24h)
  document.querySelectorAll("[id^='ndd-wrapper-']").forEach(w => {
    const sectionId = w.id.replace('ndd-wrapper-','');
    try {
      const saved = JSON.parse(localStorage.getItem(`ndd_valid_pin_${sectionId}`) || "null");
      if (saved && Date.now() - saved.ts < 24*60*60*1000) {
        const products = document.getElementById(`ndd-products-${sectionId}`);
        const modal = document.getElementById(`ndd-modal-${sectionId}`);
        w.classList.remove('ndd-blur');
        if (products) products.classList.remove('ndd-hidden');
        if (modal) modal.style.display = 'none';
      }
    } catch(e){}
  });
});
